import { useEffect, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { Field } from 'Components/Field/Field'
import { FieldTypeEnum } from 'Components/Field/Field.types'

import { useStore } from 'Stores/index'

import { useActiveUser } from 'Portal/src/hooks'

import { ShippingAddressFormAddressTypesProps } from './ShippingAddressForm.types'
import { parseAddressTypeRadioButtons } from './ShippingAddressForm.utils'

export const ShippingFormAddressTypes = (
  props: ShippingAddressFormAddressTypesProps,
) => {
  const { rental, hasDefaultValues, e2eSelector } = props
  const { portalConfigStore } = useStore()
  const { portalConfig } = portalConfigStore
  const { activeOrganisation } = useActiveUser()
  const { control, setValue, clearErrors } = useFormContext()
  const intl = useIntl()

  const watchAddressType = useWatch({
    control,
    name: 'addressType',
  })

  const addressTypesConfig = useMemo(
    () =>
      parseAddressTypeRadioButtons(
        intl,
        portalConfig,
        activeOrganisation,
        rental,
      ),
    [activeOrganisation, intl, portalConfig, rental],
  )

  // set intial address type after it is generated
  // skip if form has defaultValues
  useEffect(() => {
    if (hasDefaultValues) {
      return
    }

    setValue('addressType', addressTypesConfig[0].addressType)
    setValue('_label', addressTypesConfig[0]._label)
  }, [addressTypesConfig, hasDefaultValues, setValue])

  // on selecting address type prefill formdata with organisation/rental
  useEffect(() => {
    clearErrors()

    const fieldsToReset = addressTypesConfig.find(
      addressType => addressType.addressType === watchAddressType,
    )

    if (!fieldsToReset) {
      return
    }

    const { addressType: _addressType, ...fields } = fieldsToReset

    for (const [key, value] of Object.entries(fields)) {
      setValue(key, value)
    }
  }, [addressTypesConfig, clearErrors, setValue, watchAddressType])

  return (
    <div className="mt-4">
      {addressTypesConfig.map(addressTypeConfig => (
        <Field
          key={addressTypeConfig.addressType}
          containerClassName="mt-1"
          e2eSelector={e2eSelector}
          label={addressTypeConfig._label}
          name="addressType"
          shouldTranslateLabel={false}
          type={FieldTypeEnum.radioButton}
          value={addressTypeConfig.addressType}
        />
      ))}
    </div>
  )
}
